import type React from "react";
import type { FormField, FormSchema } from "@/lib/database";
import { EmailValidationSettings } from "./email-validation-settings";
import {
	AddressFieldSettings,
	BannerFieldSettings,
	DateFieldSettings,
	FieldGroupSettings,
	FileFieldSettings,
	GeolocationFieldSettings,
	LinkFieldSettings,
	NumberFieldSettings,
	PhoneFieldSettings,
	PollFieldSettings,
	RadioFieldSettings,
	RatingFieldSettings,
	SchedulerFieldSettings,
	SliderFieldSettings,
	SocialFieldSettings,
	StatementFieldSettings,
	TableFieldSettings,
	TagsFieldSettings,
	TextareaFieldSettings,
	TextFieldSettings,
	TimeFieldSettings,
} from "./field-settings";

interface FieldSpecificSettingsProps {
	field: FormField;
	onUpdateSettings: (updates: Partial<FormField["settings"]>) => void;
	onFieldUpdate: (field: FormField) => void;
	schema?: FormSchema;
}

export function FieldSpecificSettings({
	field,
	onUpdateSettings,
	onFieldUpdate,
	schema,
}: FieldSpecificSettingsProps) {
	const fieldSettingsMap: Record<string, React.ComponentType<any>> = {
		text: TextFieldSettings,
		number: NumberFieldSettings,
		date: DateFieldSettings,
		email: EmailValidationSettings,
		phone: PhoneFieldSettings,
		link: LinkFieldSettings,
		address: AddressFieldSettings,
		textarea: TextareaFieldSettings,
		slider: SliderFieldSettings,
		tags: TagsFieldSettings,
		social: SocialFieldSettings,
		poll: PollFieldSettings,
		rating: RatingFieldSettings,
		banner: BannerFieldSettings,
		radio: RadioFieldSettings,
		scheduler: SchedulerFieldSettings,
		time: TimeFieldSettings,
		file: FileFieldSettings,
		"field-group": FieldGroupSettings,
		table: TableFieldSettings,
		statement: StatementFieldSettings,
		geolocation: GeolocationFieldSettings,
	};

	const FieldComponent = fieldSettingsMap[field.type];

	if (!FieldComponent) {
		return null;
	}

	return (
		<FieldComponent
			field={field}
			onFieldUpdate={onFieldUpdate}
			onUpdateSettings={onUpdateSettings}
			schema={schema}
		/>
	);
}
